import { render, staticRenderFns } from "./ActivePromocodeNote.vue?vue&type=template&id=6ab2ad6a&scoped=true"
import script from "./ActivePromocodeNote.vue?vue&type=script&lang=ts"
export * from "./ActivePromocodeNote.vue?vue&type=script&lang=ts"
import style0 from "./ActivePromocodeNote.vue?vue&type=style&index=0&id=6ab2ad6a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2ad6a",
  null
  
)

export default component.exports